import React from 'react';

interface IProps {
  cssClass?: string;
  cssClassTop?: string;
  title?: string;
}

const DomainsIcon: React.FC<IProps> = ({ cssClass, cssClassTop, title }) => (
  <i title={title || ''} className={cssClassTop || 'icon-globe'} />
);

export default DomainsIcon;
